import React, { useState, useEffect } from "react";
import "./PropertyDetailsCard.css";

const CountdownTimer = ({ listingDetails, stylez }) => {
  const auctionTimeLeft = listingDetails?.auctionTimeLeft || 0;

  const [timeRemaining, setTimeRemaining] = useState(auctionTimeLeft);

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(auctionTimeLeft - elapsed, 0);
      setTimeRemaining(remaining);
    }, 1000);

    return () => clearInterval(interval); // Cleanup
  }, [auctionTimeLeft]);

  const formatTime = (time) => {
    const seconds = Math.floor((time / 1000) % 60);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const days = Math.floor(time / (1000 * 60 * 60 * 24));

    return (
      <div
        className={`timer-bid ${stylez ? stylez.join(" ") : "mt-5 p10"}`}
        style={{ fontSize: 12 }}
      >
        <p className="countFont">
          {days.toString().padStart(2, "0")}
          <span className="countFont pl5">:</span>
          <span className="countFont ml-4 pr5 pl5">
            {hours.toString().padStart(2, "0")}
          </span>
          <span className="countFont pr5">:</span>
          <span className="countFont ml-2 pr5">
            {minutes.toString().padStart(2, "0")}
          </span>
          <span className="countFont pr5">:</span>
          <span className="countFont ml-2 pr5">
            {seconds.toString().padStart(2, "0")}
          </span>
        </p>
        <p className="countDetailsFont">
          DAYS <span className="countDetailsFont ml-4 pr5 pl5">HRS</span>{" "}
          <span className="countDetailsFont ml-2 pr5">MINS</span>{" "}
          <span className="countDetailsFont ml-2 pr5">SECS</span>
        </p>
      </div>
    );
  };

  const getStatus = () => {
    const statusDetail = listingDetails?.listingStatusDetail;
    const status = listingDetails?.listingStatus;

    if (statusDetail === "UNDERREVIEW") return "Under Review";
    if (statusDetail === "SUCCESSFUL" && status === "Closed")
      return "Auction Ended";
    return "Auction Ended";
  };

  if (
    listingDetails?.listingType === "AUCN" &&
    listingDetails?.listingStatus === "Closed"
  ) {
    return (
      <div className="aucnTrnlSale text-center text-sm-left mb-2  ">
        <span className="pl25 plsm0">{getStatus()}</span>
      </div>
    );
  }

  return (
    <div className="countdown-timer-container text-center   center">
      {formatTime(timeRemaining)}
    </div>
  );
};

export default CountdownTimer;
